var _rect, _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgAddtoMyAnalog(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 24,
    rx: 4,
    fill: "#0067B9"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_6980_40759)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M5.00342 15.3383V7H4V5H6.33675C6.70494 5 7.00342 5.29848 7.00342 5.66667V14H17.0034L17.9966 9H17L17.0034 7.33331H19.332C19.7002 7.33331 19.9987 7.63179 19.9987 7.99998C19.9987 8.05449 19.992 8.10879 19.9788 8.16167L18.463 15.5C18.3888 15.7968 18.1222 16.005 17.8162 16.005H5.67008C5.3019 16.005 5.00342 15.7065 5.00342 15.3383Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M9 9H15V11H9V9Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M13 7V13H11V7H13Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M10 18.5C10 19.3284 9.32843 20 8.5 20C7.67157 20 7 19.3284 7 18.5C7 17.6716 7.67157 17 8.5 17C9.32843 17 10 17.6716 10 18.5Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M17 18.5C17 19.3284 16.3284 20 15.5 20C14.6716 20 14 19.3284 14 18.5C14 17.6716 14.6716 17 15.5 17C16.3284 17 17 17.6716 17 18.5Z",
    fill: "white"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_6980_40759"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 16,
    height: 16,
    fill: "white",
    transform: "translate(4 4)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAddtoMyAnalog);
export default __webpack_public_path__ + "static/media/addtoMyAnalog.1678ab3d627edf37cd2c172eafe74f78.svg";
export { ForwardRef as ReactComponent };